module.exports = __webpack_public_path__ + "img/LíneaT1.880f8f74.svg";